const translations = {
  cs: {
    // Nav
    news: 'Novinky',
    trainings: 'Školení',
    exhibitions: 'Výstavy',
    projects: 'Projekty',
    catalog: 'Katalog', loans: 'Zápůjčky',
    contact: 'Kontakt',
    admin: 'Admin',
    logout: 'Odhlásit se',
    profile: 'Profil',

    // Auth
    login: 'Přihlásit se',
    email: 'E-mail',
    password: 'Heslo',
    loginTitle: 'Přihlášení do portálu',
    loginSubtitle: 'Grandstream Partner Portal',
    invalidCredentials: 'Neplatný e-mail nebo heslo',

    // News
    newsTitle: 'Novinky',
    readMore: 'Číst více',
    publishedAt: 'Zveřejněno',
    noNews: 'Zatím žádné novinky.',

    // Trainings
    trainingsTitle: 'Školení',
    register: 'Přihlásit se',
    unregister: 'Odhlásit se',
    registered: 'Přihlášen/a',
    full: 'Obsazeno',
    online: 'Online',
    onsite: 'Prezenčně',
    capacity: 'Kapacita',
    trainer: 'Lektor',
    location: 'Místo',
    date: 'Datum',
    spots: 'míst volných',
    registerSuccess: 'Byli jste úspěšně přihlášeni. Potvrzení bylo zasláno na váš e-mail.',
    unregisterSuccess: 'Byli jste odhlášeni ze školení.',
    noTrainings: 'Momentálně nejsou k dispozici žádná školení.',

    // Exhibitions
    exhibitionsTitle: 'Výstavy',
    booth: 'Stánek',
    website: 'Web výstavy',
    noExhibitions: 'Momentálně nejsou plánovány žádné výstavy.',
    upcoming: 'Nadcházející',

    // Projects
    projectsTitle: 'Projektová ochrana',
    projectsSubtitle: 'Požádejte o projektovou ochranu pro vaše obchodní příležitosti',
    newProject: 'Nová žádost',
    projectName: 'Název projektu',
    endCustomer: 'Koncový zákazník',
    endCustomerAddress: 'Adresa zákazníka',
    description: 'Popis projektu',
    products: 'Produkty',
    estimatedValue: 'Předpokládaná hodnota',
    currency: 'Měna',
    submit: 'Odeslat žádost',
    cancel: 'Zrušit',
    status: 'Stav',
    statusPending: 'Čeká na schválení',
    statusApproved: 'Schváleno',
    statusRejected: 'Zamítnuto',
    discount: 'Sleva',
    adminNote: 'Poznámka',
    submittedBy: 'Odesláno',
    projectSubmitted: 'Žádost byla úspěšně odeslána.',
    noProjects: 'Zatím žádné projekty. Vytvořte novou žádost výše.',
    createdAt: 'Datum podání',

    // Contact
    contactTitle: 'Kontakt',
    contactSubtitle: 'Váš distributor Grandstream',
    departments: {
      sales: 'Obchodní oddělení',
      technical: 'Technická podpora',
      projects: 'Projektové oddělení',
    },

    // Admin
    adminDashboard: 'Administrace',
    adminUsers: 'Uživatelé',
    adminNews: 'Novinky',
    adminTrainings: 'Školení',
    adminExhibitions: 'Výstavy',
    adminProjects: 'Projekty',
    add: 'Přidat',
    edit: 'Upravit',
    delete: 'Smazat',
    save: 'Uložit',
    active: 'Aktivní',
    inactive: 'Neaktivní',
    company: 'Firma',
    role: 'Role',
    user: 'Uživatel',
    allProjects: 'Všechny projekty',
    approve: 'Schválit',
    reject: 'Zamítnout',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    newUser: 'Nový uživatel',
    companyName: 'Název firmy',
    companyIco: 'IČO',
    countryLabel: 'Země',

    // General
    loading: 'Načítání...',
    error: 'Chyba',
    close: 'Zavřít',
    back: 'Zpět',
    confirm: 'Potvrdit',
    actions: 'Akce',
    required: '* povinné pole',

    // Registration
    register: 'Registrovat se',
    registerTitle: 'Registrace partnera',
    registerSubtitle: 'Vyplňte formulář pro přístup do partnerského portálu',
    companyInfo: 'Údaje o společnosti',
    userInfo: 'Údaje o uživatele',
    titleLabel: 'Titul',
    phoneLabel: 'Telefon',
    vatNumber: 'DIČ',
    addressLabel: 'Adresa',
    cityLabel: 'Město',
    zipLabel: 'PSČ',
    stateLabel: 'Stát',
    gdprConsent: 'Souhlasím s využitím poskytnutých údajů v souladu v rozsahu a za podmínek stanovených PCV Computers, s.r.o., s nimiž jsem se seznámil.',
    interestNews: 'Mám zájem o zasílání novinek o Grandstream',
    interestTraining: 'Mám zájem o zasílání novinek týkajících se školení a výstav',
    registerSuccess: 'Registrace byla úspěšně odeslána. Vyčkejte na schválení administrátorem.',
    alreadyRegistered: 'Již máte účet?',
    pendingApproval: 'Váš účet čeká na schválení administrátorem.',
    projectApprovedPriceNote: 'Projekt byl schválen. Konkrétní cenu získáte od svého dodavatele.',
    statusDraft: 'Rozpracovaný', statusSubmitted: 'Odesláno ke schválení',
    langName: 'Čeština',
  },

  sk: {
    news: 'Novinky',
    trainings: 'Školenia',
    exhibitions: 'Výstavy',
    projects: 'Projekty',
    contact: 'Kontakt',
    admin: 'Admin',
    logout: 'Odhlásiť sa',
    profile: 'Profil',

    login: 'Prihlásiť sa',
    email: 'E-mail',
    password: 'Heslo',
    loginTitle: 'Prihlásenie do portálu',
    loginSubtitle: 'Grandstream Partner Portal',
    invalidCredentials: 'Neplatný e-mail alebo heslo',

    newsTitle: 'Novinky',
    readMore: 'Čítať viac',
    publishedAt: 'Zverejnené',
    noNews: 'Zatiaľ žiadne novinky.',

    trainingsTitle: 'Školenia',
    register: 'Prihlásiť sa',
    unregister: 'Odhlásiť sa',
    registered: 'Prihlásený/á',
    full: 'Obsadené',
    online: 'Online',
    onsite: 'Prezenčne',
    capacity: 'Kapacita',
    trainer: 'Lektor',
    location: 'Miesto',
    date: 'Dátum',
    spots: 'miest voľných',
    registerSuccess: 'Boli ste úspešne prihlásení. Potvrdenie bolo zaslané na váš e-mail.',
    unregisterSuccess: 'Boli ste odhlásení zo školenia.',
    noTrainings: 'Momentálne nie sú k dispozícii žiadne školenia.',

    exhibitionsTitle: 'Výstavy',
    booth: 'Stánok',
    website: 'Web výstavy',
    noExhibitions: 'Momentálne nie sú plánované žiadne výstavy.',
    upcoming: 'Nadchádzajúce',

    projectsTitle: 'Projektová ochrana',
    projectsSubtitle: 'Požiadajte o projektovú ochranu pre vaše obchodné príležitosti',
    newProject: 'Nová žiadosť',
    projectName: 'Názov projektu',
    endCustomer: 'Koncový zákazník',
    endCustomerAddress: 'Adresa zákazníka',
    description: 'Popis projektu',
    products: 'Produkty',
    estimatedValue: 'Predpokladaná hodnota',
    currency: 'Mena',
    submit: 'Odoslať žiadosť',
    cancel: 'Zrušiť',
    status: 'Stav',
    statusPending: 'Čaká na schválenie',
    statusApproved: 'Schválené',
    statusRejected: 'Zamietnuté',
    discount: 'Zľava',
    adminNote: 'Poznámka',
    submittedBy: 'Odoslané',
    projectSubmitted: 'Žiadosť bola úspešne odoslaná.',
    noProjects: 'Zatiaľ žiadne projekty. Vytvorte novú žiadosť vyššie.',
    createdAt: 'Dátum podania',

    contactTitle: 'Kontakt',
    contactSubtitle: 'Váš distribútor Grandstream',
    departments: {
      sales: 'Obchodné oddelenie',
      technical: 'Technická podpora',
      projects: 'Projektové oddelenie',
    },

    adminDashboard: 'Administrácia',
    adminUsers: 'Používatelia',
    adminNews: 'Novinky',
    adminTrainings: 'Školenia',
    adminExhibitions: 'Výstavy',
    adminProjects: 'Projekty',
    add: 'Pridať',
    edit: 'Upraviť',
    delete: 'Zmazať',
    save: 'Uložiť',
    active: 'Aktívny',
    inactive: 'Neaktívny',
    company: 'Firma',
    role: 'Rola',
    user: 'Používateľ',
    allProjects: 'Všetky projekty',
    approve: 'Schváliť',
    reject: 'Zamietnuť',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    newUser: 'Nový používateľ',
    companyName: 'Názov firmy',
    companyIco: 'IČO',
    countryLabel: 'Krajina',

    loading: 'Načítavanie...',
    error: 'Chyba',
    close: 'Zatvoriť',
    back: 'Späť',
    confirm: 'Potvrdiť',
    actions: 'Akcie',
    required: '* povinné pole',

    // Registration
    register: 'Registrovať sa',
    registerTitle: 'Registrácia partnera',
    registerSubtitle: 'Vyplňte formulár pre prístup do partnerského portálu',
    companyInfo: 'Údaje o spoločnosti',
    userInfo: 'Údaje o používateľovi',
    titleLabel: 'Titul',
    phoneLabel: 'Telefón',
    vatNumber: 'DIČ',
    addressLabel: 'Adresa',
    cityLabel: 'Mesto',
    zipLabel: 'PSČ',
    stateLabel: 'Štát',
    gdprConsent: 'Súhlasím s využitím poskytnutých údajov v súlade v rozsahu a za podmienok stanovených PCV Computers, s.r.o., s ktorými som sa oboznámil.',
    interestNews: 'Mám záujem o zasielanie noviniek o Grandstream',
    interestTraining: 'Mám záujem o zasielanie noviniek týkajúcich sa školení a výstav',
    registerSuccess: 'Registrácia bola úspešne odoslaná. Vyčkajte na schválenie administrátorom.',
    alreadyRegistered: 'Už máte účet?',
    pendingApproval: 'Váš účet čaká na schválenie administrátorom.',
    projectApprovedPriceNote: 'Projekt bol schválený. Konkrétnu cenu získate od svojho dodávateľa.',
    statusDraft: 'Rozpracovaný', statusSubmitted: 'Odoslané na schválenie',
    langName: 'Slovenčina',
  },

  ro: {
    news: 'Știri',
    trainings: 'Traininguri',
    exhibitions: 'Expoziții',
    projects: 'Proiecte',
    catalog: 'Catalog',
    loans: 'Împrumuturi',
    contact: 'Contact',
    admin: 'Admin',
    logout: 'Deconectare',
    profile: 'Profil',

    login: 'Autentificare',
    email: 'E-mail',
    password: 'Parolă',
    loginTitle: 'Autentificare în portal',
    loginSubtitle: 'Grandstream Partner Portal',
    invalidCredentials: 'E-mail sau parolă incorectă',

    newsTitle: 'Știri',
    readMore: 'Citește mai mult',
    publishedAt: 'Publicat la',
    noNews: 'Nu există știri momentan.',

    trainingsTitle: 'Traininguri',
    register: 'Înregistrare',
    unregister: 'Anulare',
    registered: 'Înregistrat/ă',
    full: 'Complet',
    online: 'Online',
    onsite: 'Față în față',
    capacity: 'Capacitate',
    trainer: 'Trainer',
    location: 'Locație',
    date: 'Dată',
    spots: 'locuri disponibile',
    registerSuccess: 'V-ați înregistrat cu succes. Confirmarea a fost trimisă pe e-mail.',
    unregisterSuccess: 'V-ați dezînregistrat de la training.',
    noTrainings: 'Nu există traininguri disponibile momentan.',

    exhibitionsTitle: 'Expoziții',
    booth: 'Stand',
    website: 'Site expoziție',
    noExhibitions: 'Nu există expoziții planificate momentan.',
    upcoming: 'Viitoare',

    projectsTitle: 'Protecție proiect',
    projectsSubtitle: 'Solicitați protecție pentru oportunitățile dvs. de afaceri',
    newProject: 'Cerere nouă',
    projectName: 'Numele proiectului',
    endCustomer: 'Client final',
    endCustomerAddress: 'Adresa clientului',
    description: 'Descriere proiect',
    products: 'Produse',
    estimatedValue: 'Valoare estimată',
    currency: 'Monedă',
    submit: 'Trimite cerere',
    cancel: 'Anulare',
    status: 'Status',
    statusPending: 'În așteptare',
    statusApproved: 'Aprobat',
    statusRejected: 'Respins',
    discount: 'Reducere',
    adminNote: 'Notă',
    submittedBy: 'Trimis de',
    projectSubmitted: 'Cererea a fost trimisă cu succes.',
    noProjects: 'Nu există proiecte. Creați o cerere nouă mai sus.',
    createdAt: 'Data depunerii',

    contactTitle: 'Contact',
    contactSubtitle: 'Distribuitorul dvs. Grandstream',
    departments: {
      sales: 'Departament vânzări',
      technical: 'Suport tehnic',
      projects: 'Departament proiecte',
    },

    adminDashboard: 'Administrare',
    adminUsers: 'Utilizatori',
    adminNews: 'Știri',
    adminTrainings: 'Traininguri',
    adminExhibitions: 'Expoziții',
    adminProjects: 'Proiecte',
    add: 'Adăugare',
    edit: 'Editare',
    delete: 'Ștergere',
    save: 'Salvare',
    active: 'Activ',
    inactive: 'Inactiv',
    company: 'Companie',
    role: 'Rol',
    user: 'Utilizator',
    allProjects: 'Toate proiectele',
    approve: 'Aprobă',
    reject: 'Respinge',
    firstName: 'Prenume',
    lastName: 'Nume',
    newUser: 'Utilizator nou',
    companyName: 'Nume companie',
    companyIco: 'CUI',
    countryLabel: 'Țară',

    loading: 'Se încarcă...',
    error: 'Eroare',
    close: 'Închide',
    back: 'Înapoi',
    confirm: 'Confirmare',
    actions: 'Acțiuni',
    required: '* câmp obligatoriu',

    // Registration
    register: 'Înregistrare',
    registerTitle: 'Înregistrare partener',
    registerSubtitle: 'Completați formularul pentru acces la portalul de parteneri',
    companyInfo: 'Date despre companie',
    userInfo: 'Date despre utilizator',
    titleLabel: 'Titlu',
    phoneLabel: 'Telefon',
    vatNumber: 'CUI',
    addressLabel: 'Adresă',
    cityLabel: 'Oraș',
    zipLabel: 'Cod poștal',
    stateLabel: 'Țară',
    gdprConsent: 'Sunt de acord cu utilizarea datelor furnizate în conformitate cu condițiile stabilite de PCV Computers, s.r.o.',
    interestNews: 'Sunt interesat de primirea noutăților despre Grandstream',
    interestTraining: 'Sunt interesat de primirea noutăților despre training-uri și expoziții',
    registerSuccess: 'Înregistrarea a fost trimisă cu succes. Așteptați aprobarea administratorului.',
    alreadyRegistered: 'Aveți deja un cont?',
    pendingApproval: 'Contul dvs. așteaptă aprobarea administratorului.',
    projectApprovedPriceNote: 'Proiectul a fost aprobat. Prețul concret îl veți obține de la furnizorul dvs.',
    statusDraft: 'Ciornă', statusSubmitted: 'Trimis pentru aprobare',
    langName: 'Română',
  },

  en: {
    news: 'News', trainings: 'Trainings', exhibitions: 'Exhibitions', projects: 'Projects',
    catalog: 'Catalog', loans: 'Loans', contact: 'Contact', admin: 'Admin',
    logout: 'Log out', profile: 'Profile',
    login: 'Log in', email: 'E-mail', password: 'Password',
    loginTitle: 'Partner Portal Login', loginSubtitle: 'Grandstream Partner Portal',
    invalidCredentials: 'Invalid email or password',
    newsTitle: 'News', readMore: 'Read more', publishedAt: 'Published', noNews: 'No news yet.',
    trainingsTitle: 'Trainings & Certifications',
    register: 'Register', unregister: 'Unregister', registered: 'Registered',
    full: 'Full', online: 'Online', onsite: 'On-site', capacity: 'Capacity',
    trainer: 'Trainer', location: 'Location', date: 'Date', spots: 'spots available',
    registerSuccess: 'Successfully registered. Confirmation sent to your email.',
    unregisterSuccess: 'You have been unregistered from the training.',
    noTrainings: 'No trainings available at the moment.',
    exhibitionsTitle: 'Exhibitions', booth: 'Booth', website: 'Exhibition website',
    noExhibitions: 'No exhibitions planned at the moment.', upcoming: 'Upcoming',
    projectsTitle: 'Project Protection',
    projectsSubtitle: 'Request project protection for your business opportunities',
    newProject: 'New request', projectName: 'Project name', endCustomer: 'End customer',
    endCustomerAddress: 'Customer address', description: 'Project description',
    products: 'Products', estimatedValue: 'Estimated value', currency: 'Currency',
    submit: 'Submit request', cancel: 'Cancel', status: 'Status',
    statusPending: 'Pending', statusApproved: 'Approved', statusRejected: 'Rejected',
    discount: 'Discount', adminNote: 'Note', submittedBy: 'Submitted by',
    projectSubmitted: 'Request submitted successfully.',
    noProjects: 'No projects yet. Create a new request above.', createdAt: 'Submission date',
    contactTitle: 'Contact', contactSubtitle: 'Your Grandstream Distributor',
    departments: { sales: 'Sales', technical: 'Technical Support', projects: 'Projects' },
    adminDashboard: 'Administration', adminUsers: 'Users', adminNews: 'News',
    adminTrainings: 'Trainings', adminExhibitions: 'Exhibitions', adminProjects: 'Projects',
    add: 'Add', edit: 'Edit', delete: 'Delete', save: 'Save',
    active: 'Active', inactive: 'Inactive', company: 'Company', role: 'Role', user: 'User',
    allProjects: 'All projects', approve: 'Approve', reject: 'Reject',
    firstName: 'First name', lastName: 'Last name', newUser: 'New user',
    companyName: 'Company name', companyIco: 'Company ID', countryLabel: 'Country',
    loading: 'Loading...', error: 'Error', close: 'Close', back: 'Back',
    confirm: 'Confirm', actions: 'Actions', required: '* required field', langName: 'English',
    statusDraft: 'Draft', statusSubmitted: 'Submitted for approval',
    projectApprovedPriceNote: 'The project has been approved. You will receive the specific price from your supplier.',
    register: 'Register', registerTitle: 'Partner Registration', registerSubtitle: 'Fill in the form to access the partner portal',
    companyInfo: 'Company Information', userInfo: 'User Information', titleLabel: 'Title', phoneLabel: 'Phone',
    vatNumber: 'VAT Number', addressLabel: 'Address', cityLabel: 'City', zipLabel: 'ZIP Code', stateLabel: 'Country',
    gdprConsent: 'I agree to the use of the provided data in accordance with the conditions set by PCV Computers, s.r.o.',
    interestNews: 'I am interested in receiving Grandstream news',
    interestTraining: 'I am interested in news about trainings and exhibitions',
    registerSuccess: 'Registration submitted. Please wait for administrator approval.',
    alreadyRegistered: 'Already have an account?', pendingApproval: 'Your account is pending approval.',
  },

  hu: {
    news: 'Hírek', trainings: 'Képzések', exhibitions: 'Kiállítások', projects: 'Projektek',
    catalog: 'Katalógus', loans: 'Kölcsönzés', contact: 'Kapcsolat', admin: 'Admin',
    logout: 'Kijelentkezés', profile: 'Profil',
    login: 'Bejelentkezés', email: 'E-mail', password: 'Jelszó',
    loginTitle: 'Partner Portal bejelentkezés', loginSubtitle: 'Grandstream Partner Portal',
    invalidCredentials: 'Érvénytelen e-mail vagy jelszó',
    newsTitle: 'Hírek', readMore: 'Tovább', publishedAt: 'Közzétéve', noNews: 'Még nincsenek hírek.',
    trainingsTitle: 'Képzések és tanúsítványok',
    register: 'Regisztráció', unregister: 'Lemondás', registered: 'Regisztrált',
    full: 'Betelt', online: 'Online', onsite: 'Személyes', capacity: 'Kapacitás',
    trainer: 'Oktató', location: 'Helyszín', date: 'Dátum', spots: 'szabad hely',
    registerSuccess: 'Sikeresen regisztrált. Visszaigazolás elküldve az e-mail címére.',
    unregisterSuccess: 'Lemondta a képzést.',
    noTrainings: 'Jelenleg nincs elérhető képzés.',
    exhibitionsTitle: 'Kiállítások', booth: 'Stand', website: 'Kiállítás weboldala',
    noExhibitions: 'Jelenleg nincs tervezett kiállítás.', upcoming: 'Közelgő',
    projectsTitle: 'Projektvédelem',
    projectsSubtitle: 'Kérjen projektvédelmet üzleti lehetőségeihez',
    newProject: 'Új kérelem', projectName: 'Projekt neve', endCustomer: 'Végfelhasználó',
    endCustomerAddress: 'Ügyfél címe', description: 'Projekt leírása',
    products: 'Termékek', estimatedValue: 'Becsült érték', currency: 'Pénznem',
    submit: 'Kérelem benyújtása', cancel: 'Mégse', status: 'Állapot',
    statusPending: 'Függőben', statusApproved: 'Jóváhagyva', statusRejected: 'Elutasítva',
    discount: 'Kedvezmény', adminNote: 'Megjegyzés', submittedBy: 'Benyújtotta',
    projectSubmitted: 'Kérelem sikeresen benyújtva.',
    noProjects: 'Még nincsenek projektek. Hozzon létre egy újat fent.', createdAt: 'Benyújtás dátuma',
    contactTitle: 'Kapcsolat', contactSubtitle: 'Az Ön Grandstream disztribútora',
    departments: { sales: 'Értékesítés', technical: 'Műszaki támogatás', projects: 'Projektek' },
    adminDashboard: 'Adminisztráció', adminUsers: 'Felhasználók', adminNews: 'Hírek',
    adminTrainings: 'Képzések', adminExhibitions: 'Kiállítások', adminProjects: 'Projektek',
    add: 'Hozzáadás', edit: 'Szerkesztés', delete: 'Törlés', save: 'Mentés',
    active: 'Aktív', inactive: 'Inaktív', company: 'Cég', role: 'Szerepkör', user: 'Felhasználó',
    allProjects: 'Összes projekt', approve: 'Jóváhagyás', reject: 'Elutasítás',
    firstName: 'Keresztnév', lastName: 'Vezetéknév', newUser: 'Új felhasználó',
    companyName: 'Cégnév', companyIco: 'Adószám', countryLabel: 'Ország',
    loading: 'Betöltés...', error: 'Hiba', close: 'Bezárás', back: 'Vissza',
    confirm: 'Megerősítés', actions: 'Műveletek', required: '* kötelező mező', langName: 'Magyar',
    statusDraft: 'Piszkozat', statusSubmitted: 'Jóváhagyásra beküldve',
    projectApprovedPriceNote: 'A projektet jóváhagyták. A konkrét árat a szállítójától kapja meg.',
    register: 'Regisztráció', registerTitle: 'Partner regisztráció', registerSubtitle: 'Töltse ki az űrlapot a partnerportálhoz való hozzáféréshez',
    companyInfo: 'Céges adatok', userInfo: 'Felhasználói adatok', titleLabel: 'Titulus', phoneLabel: 'Telefon',
    vatNumber: 'Adószám', addressLabel: 'Cím', cityLabel: 'Város', zipLabel: 'Irányítószám', stateLabel: 'Ország',
    gdprConsent: 'Hozzájárulok az adatok felhasználásához a PCV Computers, s.r.o. feltételei szerint.',
    interestNews: 'Érdeklem a Grandstream hírek fogadása',
    interestTraining: 'Érdeklem a képzésekről szóló hírek fogadása',
    registerSuccess: 'A regisztráció elküldve. Várja meg az adminisztrátor jóváhagyását.',
    alreadyRegistered: 'Már van fiókja?', pendingApproval: 'A fiókja jóváhagyásra vár.',
  },
};

export default translations;
